import type { Sprint } from '../../model/index.tsx';
import getActiveSprints from '../../rest/get-active-sprints/index.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default async (baseUrl: string, boardId: string): Promise<Sprint[]> => {
	const activeSprints = await getActiveSprints(baseUrl, boardId);
	return activeSprints.values;
};
